// @ai-generated 2026-09-03T12:05:00+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { SEEDING_CLIENT_ID } from '@Constants/seedingClientConstants';
import { useSession } from '@Contexts/session/SessionContext';

/**
 * Whether the current session may author system-wide records.
 */
export function useHasSystemAccess(): boolean {
    const {
        current: { clientId },
    } = useSession();

    return clientId === SEEDING_CLIENT_ID;
}
